import { useDispatch, useSelector } from 'react-redux';
import {axiosInstance} from '../auth'


export const SET = 'settingSet';
export const SET_LOADING = 'settingLoading';
export const CLEAR = 'settingClear';

export const useSetting = () => {
  const settings = useSelector((state) => state.settings);
  const dispatch = useDispatch();
  return {
    ...settings,
    dispatch,
    getSetting,
    submitSetting
  };
};


export const submitSetting = (data,cb=()=>{}) => async (dispatch) => {
  try {
    dispatch({type:SET_LOADING, payload:{loading:true}});
      const result = await axiosInstance.post('/panel/settings', data);
      dispatch({
        type:SET,
        payload:{[result.data.key]:result.data.value,loading:false}
      })
    cb();
  } catch (e) {
    dispatch({type:SET_LOADING,
      payload:{loading:false}});
      console.log(e);
  }
};

export const getSetting = (key) => async (dispatch) => {
  try {
    dispatch({type:SET_LOADING,
      payload:{loading:true}});
      const result = await axiosInstance.get('/panel/settings/'+key);
      dispatch({
        type:SET,
        payload:{[key]:result.data.value,loading:false}
      })
  } catch (e) {
    dispatch({type:SET_LOADING,
      payload:{loading:false}});
      console.log(e);
  }
};
